// extracted by mini-css-extract-plugin
export default {"label":"label___bYIYr","label_wrapper":"label_wrapper___NrwrF","label_radio":"label_radio___L79ie"};